import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonModalServiceService {
  private readonly _modalHeaderTitleState = signal<any>(null);
  private readonly _modalHeaderIsCloseBtnVisibleState = signal<boolean>(false);
  private readonly _modalHeaderIsSaveBtnVisibleState = signal<boolean>(false);

  private _isSyncingFromSubject = false;

  _modalHeaderTitle = new BehaviorSubject<any>(null);
  modalHeaderTitle$ = this._modalHeaderTitle.asObservable();
  modalHeaderTitleSignal = this._modalHeaderTitleState.asReadonly();
  modalHeaderTitleSignal$ = toObservable(this._modalHeaderTitleState);

  _modalHeaderIsCloseBtnVisible = new BehaviorSubject<any>(false);
  modalHeaderIsCloseBtnVisible$ = this._modalHeaderIsCloseBtnVisible.asObservable();
  modalHeaderIsCloseBtnVisibleSignal = this._modalHeaderIsCloseBtnVisibleState.asReadonly();
  modalHeaderIsCloseBtnVisibleSignal$ = toObservable(this._modalHeaderIsCloseBtnVisibleState);

  _modalHeaderIsSaveBtnVisible = new BehaviorSubject<any>(false);
  modalHeaderIsSaveBtnVisible$ = this._modalHeaderIsSaveBtnVisible.asObservable();
  modalHeaderIsSaveBtnVisibleSignal = this._modalHeaderIsSaveBtnVisibleState.asReadonly();
  modalHeaderIsSaveBtnVisibleSignal$ = toObservable(this._modalHeaderIsSaveBtnVisibleState);

  constructor() {
    this._modalHeaderTitle.subscribe((value) => {
      if (this._isSyncingFromSubject) {
        return;
      }
      this._modalHeaderTitleState.set(value);
    });

    this._modalHeaderIsCloseBtnVisible.subscribe((value) => {
      if (this._isSyncingFromSubject) {
        return;
      }
      this._modalHeaderIsCloseBtnVisibleState.set(!!value);
    });

    this._modalHeaderIsSaveBtnVisible.subscribe((value) => {
      if (this._isSyncingFromSubject) {
        return;
      }
      this._modalHeaderIsSaveBtnVisibleState.set(!!value);
    });
  }




  updateHeaderTitle(title: string) {
    this._modalHeaderTitleState.set(title);
    this.syncSubjectsFromSignals();
  }

  updateCloseBtnVisiblity(isVisible: boolean) {
    this._modalHeaderIsCloseBtnVisibleState.set(isVisible);
    this.syncSubjectsFromSignals();
  }

  updateSaveBtnVisiblity(isVisible: boolean) {
    this._modalHeaderIsSaveBtnVisibleState.set(isVisible);
    this.syncSubjectsFromSignals();
  }

  // Signal-first APIs for new consumers.
  setModalHeaderTitle(title: string): void {
    this.updateHeaderTitle(title);
  }

  setModalCloseButtonVisibility(isVisible: boolean): void {
    this.updateCloseBtnVisiblity(isVisible);
  }

  setModalSaveButtonVisibility(isVisible: boolean): void {
    this.updateSaveBtnVisiblity(isVisible);
  }

  private syncSubjectsFromSignals(): void {
    this._isSyncingFromSubject = true;
    this._modalHeaderTitle.next(this._modalHeaderTitleState());
    this._modalHeaderIsCloseBtnVisible.next(this._modalHeaderIsCloseBtnVisibleState());
    this._modalHeaderIsSaveBtnVisible.next(this._modalHeaderIsSaveBtnVisibleState());
    this._isSyncingFromSubject = false;
  }


}
